module.exports = __webpack_public_path__ + "img/food-30.0f8837ad.jpg";